// Module
var code = `<fdx-modal-hoc modal-theme="danger" modal-title="Confirm Transformer Delete" submit-text="Delete" on-submit="\$ctrl.onSubmit()" on-cancel="\$ctrl.onCancel()"> Are you sure you'd like to delete all <strong>{{ \$ctrl.transformerCount }}</strong> transformer(s) associated with <strong>{{ \$ctrl.displayName }}</strong>? </fdx-modal-hoc>`;
// Exports
module.exports = code;